import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

import { of } from 'rxjs';

import { CamAbstractInput, InputDropdown, InputPanel, InputTextarea } from '@camelot/form-model';
import { TranslatedEnumeration } from '@camelot/services';

import { UploadDocumentData } from './upload-document-data';

@Injectable({
  providedIn: 'root',
})
export class UploadDocumentFormService {
  public getGroupForm(data: UploadDocumentData): CamAbstractInput[] {
    return [
      new InputPanel({
        key: 'panel',
        label: 'files.documents.upload.dialog.title',
        containerClass: ['highlight-title', 'no-title-space', 'p-20'],
        children: [
          new InputDropdown({
            key: 'documentType',
            label: 'files.documents.upload.dialog.document-type',
            options: data.documentTypes$.pipe(
              map((fileTypes: TranslatedEnumeration[]) => {
                return fileTypes.map(fileType => {
                  return {
                    id: fileType.id.toString(),
                    name: fileType.translatedValue,
                  };
                });
              })
            ),
            multiple: false,
            visible$: of(true),
          }),
          new InputTextarea({
            key: 'description',
            label: 'files.documents.upload.dialog.description',
            value: data.description,
          }),
        ],
      }),
    ];
  }
}
